exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.theme-picker .el-color-picker__trigger {\n  vertical-align: middle;\n}\n.theme-picker-dropdown .el-color-dropdown__link-btn {\n  display: none;\n}\n", ""]);

// exports
